import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Star } from "lucide-react";
import { MaskLines } from "@/components/home/Reveal";
import HeroObjects from "@/components/home/HeroObjects";

const HeroSection = () => (
  <section className="relative pt-32 md:pt-44 pb-12 md:pb-24 px-4 overflow-hidden">
    <HeroObjects />
    <div className="relative z-10 container mx-auto max-w-6xl text-center">
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <Link
          to="/rdv"
          className="inline-flex items-center gap-2 rounded-full border border-border bg-card pl-2 pr-4 py-1.5 text-xs md:text-sm font-medium hover:border-foreground/30 transition-colors"
        >
          <span className="rounded-full bg-tile-lime text-tile-ink px-2.5 py-0.5 font-semibold">24h/24</span>
          Ouvert 7j/7 · Jours fériés inclus
          <ArrowRight size={14} />
        </Link>
      </motion.div>

      <MaskLines
        as="h1"
        delay={0.1}
        className="text-giant mt-7 md:mt-9 text-foreground"
        lines={[
          <>Dépannage, PC &amp; Web</>,
          <>à <span className="text-primary">Béziers</span>.</>,
        ]}
      />

      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.45, duration: 0.6 }}
        className="mt-6 md:mt-8 text-base md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed"
      >
        SUDWEB-TECH dépanne votre informatique, assemble votre PC sur mesure et crée votre site web, partout dans l'Hérault.
      </motion.p>

      <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.55, duration: 0.6 }} className="mt-8 md:mt-10">
        <motion.a
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.96 }}
          href="tel:+33669260492"
          className="inline-flex items-center gap-2 h-14 px-8 rounded-full bg-primary text-primary-foreground font-semibold text-base shadow-[var(--shadow-glow)]"
        >
          Appeler le 06 69 26 04 92 <ArrowRight size={18} />
        </motion.a>
      </motion.div>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.75, duration: 0.6 }}
        className="mt-6 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-sm text-muted-foreground"
      >
        <span className="inline-flex items-center gap-1 text-foreground font-semibold">
          <Star size={14} className="fill-warning text-warning" /> 4.9/5 sur Google
        </span>
        <span>Diagnostic 75€</span>
        <span>Devis gratuit</span>
        <span>Garantie 2 ans</span>
      </motion.p>
    </div>
  </section>
);

export default HeroSection;
